/* eslint-disable eqeqeq */
import React, { Component } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import Autocomplete from 'react-autocomplete';
import ProductsAction from '../../app/store/actions/products';
import { getCategoriesAction } from '../../app/store/actions/categories';
import RecommendedAction from '../../app/store/actions/recommended';

import FIELDS from '../../data/fields';

let productHelper = '';

class RecommendedFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      productId: '',
      productDescription: '',
      categoryId: '',
      categoryName: '',
      limit: 10,
      skip: 0,
      message: '',
      success: '',
    };
  }

  componentDidMount() {
    const { limit, skip } = this.state;
    this.props.searchProductsCheckbuy(limit, skip);
    this.props.getCategories();
    if (this.props.back.location.item) {
      const {
        id, productId, product, categoryId, category,
      } = this.props.back.location.item;

      this.setState({
        productDescription: product.description,
        categoryName: category && category.name,
        id,
        productId,
        categoryId,
      });
    }
  }

  setCategory = (id) => {
    this.setState({ categoryId: id, message: '', success: '' });
  };

  goBack = () => {
    this.props.back.goBack();
  };

  setOnChange = (productDescription) => {
    this.props.searchProductsCheckbuy(10, productDescription);
    this.setState({ productDescription });
  };


  setSelectedProductId = (description) => {
    const productDescription = description.value;
    let categoryName = '';
    let categoryIdAux = productHelper.categoryId;

    this.props.categories.forEach((row) => {
      if (row.id == productHelper.categoryId) {
        categoryName = row.name;
        categoryIdAux = row.id;
        return;
      }
      if (row.categories) {
        const result = row.categories.find(obj => obj.id === productHelper.categoryId);
        if (result) {
          categoryName = row.name;
          categoryIdAux = row.id;
        }
      }
    });

    this.setState({
      productDescription, productId: productHelper.soneparId, categoryId: categoryIdAux, categoryName,
    });
  };

  setSelectedProduct = (item) => {
    productHelper = item;
    return `${item.code} ${item.description}`;
  };

  getSubCategories = categories => categories.map(subCategories => (
    <option key={subCategories.id} value={subCategories.id}>
      {'---- '}
      {subCategories.name}
    </option>
  ));

  getCategories = categories => (
    categories.map(category => (
      <React.Fragment key={category.id}>
        <option key={category.id} value={category.id}>{category.name}</option>
      </React.Fragment>
    )))

  isValidData = async () => {
    const {
      productId, categoryId,
    } = this.state;

    if (!productId) await this.setState({ message: I18n.t('selectProduct'), success: '' });
    else if (!categoryId) await this.setState({ message: I18n.t('selectCategory'), success: '' });
    else {
      return true;
    }
  };

  createRecommended = async () => {
    const {
      productId, categoryId,
    } = this.state;

    if (await this.isValidData()) {
      try {
        await this.props.createRecommended({
          productId,
          categoryId,
        });
        this.setState({
          success: I18n.t('recommendedCreated'),
          message: '',
          id: '',
          productId: '',
          productDescription: '',
          categoryId: '',
          categoryName: '',
        });
      } catch (err) {
        this.setState({ message: I18n.t('errorOcurred'), success: '' });
      }
    }
  };

  updateRecommended = async () => {
    const {
      productId, categoryId, id,
    } = this.state;

    if (await this.isValidData()) {
      try {
        await this.props.updateRecommended({
          id,
          productId,
          categoryId,
        });
        this.setState({ success: I18n.t('recommendedUpdated'), message: '' });
      } catch (err) {
        this.setState({ message: I18n.t('errorOcurred'), success: '' });
      }
    }
  };

  render() {
    const {
      productId, productDescription, categoryId, categoryName, message, success, id,
    } = this.state;
    const { products, categories } = this.props;
    return (
      <div className="form-main">
        <h2 className="header-form-client"><Translate value="recommendedRegister" /></h2>
        <form>

          <div className="form-group search-custom-input">
            <p className="margin-bottom-2"><Translate value="product" /></p>
            <Autocomplete
              getItemValue={item => this.setSelectedProduct(item)}
              items={products || []}
              className="custom-select"
              maxLength={FIELDS.max}
              renderItem={(item, isHighlighted) => (
                <div style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                  {item.code}
                  {' '}
                  {item.description}
                  {' '}
                  {item.product.narrativa}
                </div>
              )}
              value={productDescription}
              onChange={e => this.setOnChange(e.target.value)}
              onSelect={e => this.setSelectedProductId({ value: e })}
            />
          </div>

          <div className="form-group">
            <p className="margin-bottom-2"><Translate value="category" /></p>
            <select className="custom-select" onChange={e => this.setCategory(e.target.value)} required>
              <option value={categoryId}>{categoryName}</option>
              {categories && this.getCategories(categories)}
            </select>
            <div className="invalid-feedback"><Translate value="selectBrand" /></div>
          </div>


          {success && <p className="color-green margin-top-10">{success}</p>}
          {message && <p className="color-red margin-top-10">{message}</p>}

          <div className="row margin-left-0 margin-top-10">
            <button
              type="button"
              onClick={() => this.goBack()}
              className="btn btn-warning margin-right-15"
            >
              <Translate value="return" />
            </button>
            {id
              ? (
                <button
                  type="button"
                  className="btn btn-dark"
                  onClick={() => this.updateRecommended()}
                >
                  <Translate value="update" />
                </button>
              )
              : (
                <button
                  type="button"
                  className="btn btn-dark"
                  onClick={() => this.createRecommended()}
                >
                  <Translate value="save" />
                </button>
              )
            }
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  searchProductsCheckbuy: (limit, search) => { dispatch(ProductsAction.searchProductsCheckbuy(limit, search)); },
  getCategories: () => { dispatch(getCategoriesAction()); },
  createRecommended: recommended => dispatch(RecommendedAction.createRecommended(recommended)),
  updateRecommended: recommended => dispatch(RecommendedAction.updateRecommended(recommended)),
});

const mapStateToProps = state => ({
  products: state.products.productsCheckbuy,
  categories: state.categories.categories,
});

export default connect(mapStateToProps, mapDispatchToProps)(RecommendedFormComponent);
